import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import FilePreview from "../../../filePreview/FilePreview";
import Checkbox from "../../../input/checkbox/Checkbox";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function HouserulesStepView({
  controller,
  read,
  accepted,
  onRead,
  onAcceptChange,
}) {
  const theme = useTheme();
  const { translateEntity, translate } = useLanguageContext();

  return (
    <FlowPlayerControls
      controller={controller}
      disabledNavItems={!accepted ? ["next"] : []}
    >
      <StyledFlexColumn>
        <FilePreview
          path={translateEntity(controller.step.file, "path")}
          closeable={read}
          onRead={onRead}
        >
          <p>
            {translate(
              "eva.frontoffice.pages.visitor_type.steps.houserule.accept_question",
              [
                {
                  key: "houserules",
                  value: (
                    <span
                      style={{
                        fontWeight: "bold",
                        color:
                          theme["settings.button.color.primary.background"],
                      }}
                    >
                      {translate(
                        "eva.frontoffice.pages.visitor_type.steps.houserule.label",
                      ).toLowerCase()}
                    </span>
                  ),
                },
              ],
            )}
          </p>
        </FilePreview>

        <Checkbox
          value={accepted}
          disabled={!read}
          label={translate(
            "eva.frontoffice.pages.visitor_type.steps.houserule.accept",
          )}
          onChange={onAcceptChange}
        />
      </StyledFlexColumn>
    </FlowPlayerControls>
  );
}

export default HouserulesStepView;
